import { render, staticRenderFns } from "./PsoriasisBodyModel.vue?vue&type=template&id=08023808&scoped=true&"
import script from "./PsoriasisBodyModel.vue?vue&type=script&lang=js&"
export * from "./PsoriasisBodyModel.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisBodyModel.vue?vue&type=style&index=0&id=08023808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08023808",
  null
  
)

export default component.exports